import React from 'react'
import PropTypes from 'prop-types'
import { Step } from '../../../Steps'

export const WizardbarItem = ({ text, active, step }) => {
  const props = { text, active, step }
  return <Step {...props} />
}

WizardbarItem.propTypes = {
  step: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
}

WizardbarItem.defaultProps = {
  active: false,
}
